const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速播放不缓冲',
    desc: '智能 CDN 加速技术，自适应带宽优化，看高清不卡顿、不缓冲，流畅追剧每一秒都丝滑顺畅，告别转圈等待。',
    color: 'primary' as const,
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净观影无广告',
    desc: '全程无弹窗、无贴片、无强制跳转，干净的观影环境让你沉浸式追剧。不收集个人信息，安全又放心。',
    color: 'accent' as const,
  },
  {
    icon: 'ri-device-line',
    title: '多端同步看片',
    desc: '电脑、平板、手机全平台覆盖，观影进度云端同步，在家用大屏、出门用手机，随时随地无缝续看。',
    color: 'secondary' as const,
  },
];

const colorMap = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-500', badge: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-500', badge: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-500', badge: 'bg-secondary-500' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            为什么千万用户选择青柠影视？答案在这里
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => {
            const c = colorMap[feat.color];
            return (
              <div
                key={idx}
                className="bg-background-100 rounded-xl p-6 md:p-8 text-center border border-background-200/70 hover:border-primary-300/50 transition-all duration-200"
              >
                <div className={`w-16 h-16 md:w-18 md:h-18 flex items-center justify-center mx-auto mb-5 rounded-2xl ${c.bg}`}>
                  <i className={`${feat.icon} ${c.icon} text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                  {feat.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}